import React from 'react';
import PropTypes from 'prop-types';

import { Logger } from 'aws-amplify';

import {
    Snackbar,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
    Alert as MuiAlert,
} from '@material-ui/lab';

const logger = new Logger('Message');

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function Message(props) {
 
  const { value, severity, duration } = props;
  
  const classes = useStyles();
 
  const [open, setOpen] = React.useState(true);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  
  logger.debug("MESSAGE: ", value);

  if(!value) {
    return(null);
  }

  return (
    <div className={classes.root}>
      <Snackbar open={open} autoHideDuration={duration} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {value}
        </Alert>
      </Snackbar>
    </div>
  );
}

Message.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  duration: PropTypes.number,
};

Message.defaultProps = {
  variant: 'error',
  duration: 6000,
};
